import React from 'react'
import { Link } from '@mui/material'
import AppBar from '@mui/material/AppBar'
import Typography from '@mui/material/Typography'

import { HEADER_HEIGHT } from '@/constants'
import { neutral } from '@/Theme/colors'

import Container from '@/Components/Layout/Container'
import Nav from '@/Components/Layout/Nav/Nav'

type HeaderProps = {}

const Header: React.FC<HeaderProps> = () => {
  return (
    <AppBar
      position="static"
      elevation={0}
      sx={{
        backgroundColor: neutral,
        height: HEADER_HEIGHT,
        borderBottom: '2px solid',
        borderBottomColor: 'primary.main'
      }}
    >
      <Container
        sx={{
          flex: 1,
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        <Link href="/assessments" underline="none">
          <Typography
            variant="h1"
            color="primary"
            sx={{
              textTransform: 'uppercase',
              fontSize: 36,
              lineHeight: 1,
              pt: 0.75
            }}
          >
            Greener Stores
          </Typography>
        </Link>
        <Nav />
      </Container>
    </AppBar>
  )
}

export default Header
